<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button @click="dialogFormVisible = true" icon="iconfont iconhexiaoqueren shuaxin" size="small" type="warning" :disabled="!power.goods_order_set_status_code">号码核销</el-button>
                <el-button type="success" size="small" icon="iconfont icon-daochu shuaxin" @click="exportExcel" :disabled="!power.goods_order_excel">导出Excel</el-button>
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.is_pay" placeholder="请选择支付状态" size="small" clearable>
                        <el-option
                            v-for="item in [
                              {id: 1, name: '已支付'},
                              {id: 0, name: '未支付'},
                            ]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.phone" size="small" type="number" placeholder="请输入会员手机号码" clearable></el-input>
                </div>
                <div class="search-item">
                  <el-date-picker
                    v-model="data.created_at"
                    size="small"
                    :picker-options="pickerOptions"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="下单开始时间"
                    end-placeholder="下单结束时间">
                  </el-date-picker>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="order_no" label="订单编号" width="180"></el-table-column>
                    <el-table-column prop="goods_title" label="商品标题" width="180"></el-table-column>
                    <el-table-column prop="user_name" label="会员昵称" width="150"></el-table-column>
                    <el-table-column prop="phone" label="手机号码" width="120"></el-table-column>
                    <el-table-column prop="num" label="数量" width="80"></el-table-column>
                    <el-table-column prop="price" label="价格" width="80"></el-table-column>
                    <el-table-column prop="integral" label="积分" width="80"></el-table-column>
                    <el-table-column prop="total_amount" label="总金额" width="80"></el-table-column>
                    <el-table-column prop="is_pay" label="支付状态" width="80">
                      <template slot-scope="scope">
                        <span v-if="scope.row.is_pay == 1" style="color: #67C23A;">已支付</span>
                        <span v-if="scope.row.is_pay == 0" style="color: #F56C6C;">未支付</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="qr_code_num" label="核销号码" width="100"></el-table-column>
                    <!-- <el-table-column prop="qr_code" label="核销二维码" width="100">
                      <template slot-scope="scope">
                        <el-popover
                          placement="right"
                          width="150"
                          trigger="click">
                          <el-image
                            style="width: 150px; height: 150px"
                            :src="scope.row.qr_code">
                          </el-image>
                          <el-image
                            slot="reference"
                            style="width: 50px; height: 50px; cursor: pointer;"
                            :src="scope.row.qr_code">
                          </el-image>
                        </el-popover>
                      </template>
                    </el-table-column> -->
                    <el-table-column prop="status" label="核销状态" width="100">
                      <template slot-scope="scope" v-if="scope.row.is_pay == 1">
                        <span v-if="scope.row.status == 1" style="color: #F56C6C;">已核销</span>
                        <span v-if="scope.row.status == 0" style="color: #67C23A;">未核销</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="remarks" label="备注" width="100"></el-table-column>
                    <el-table-column prop="created_at" label="下单时间" width="160"></el-table-column>
                    <el-table-column label="操作" min-width="100">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status == 0 && scope.row.is_pay == 1" @click="setStatus(scope.row.id)" icon="iconfont iconhexiaoqueren shuaxin" size="mini" type="warning" plain :disabled="!power.goods_order_set_status">核销</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

      <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="550px" center>
          <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
              <el-form-item label="核销号码"
                  :label-width="formLabelWidth"
                  prop="qr_code_num"
                  :rules="[
                  { required: true, message: '请输入核销号码', trigger: 'blur' }
                  ]">
                  <el-input type="number" v-model="form.qr_code_num" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="核销员工"
                  :label-width="formLabelWidth"
                  prop="staff_id"
                  :rules="[
                  { required: true, message: '请选择核销员工', trigger: 'blur' }
                  ]">
                  <el-select v-model="form.staff_id" placeholder="请选择核销员工">
                      <el-option
                          v-for="item in staffList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="setStatusCode('form')">确 定</el-button>
          </div>
      </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {GoodsOrderIndex, GoodsOrderSetStatus, GoodsOrderSetStatusCode} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    is_pay: '',
                    phone: '',
                    created_at: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "核销商城订单",
                formLabelWidth: "120px",
                form: {
                    qr_code_num: "",
                    staff_id: "",
                },
                multipleSelection: [],
                staffList: [],
                pickerOptions: {
                  shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近一个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近三个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                      picker.$emit('pick', [start, end]);
                    }
                  }]
                },
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power", "loginInfo"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                GoodsOrderIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                        this.staffList = res.data.staffList
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            setStatus(id) {
                this.$confirm("确定要核销当前订单吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    GoodsOrderSetStatus({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
            setStatusCode(formName) {
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      this.loadingAdd = true
                      GoodsOrderSetStatusCode(this.form).then((res) => {
                          if (res.code == 200) {
                              this.$message.success(res.msg);
                              this.dialogFormVisible = false
                              this.data.page--
                              this.getList()
                          } else {
                              this.$message.error(res.msg);
                          }
                          this.loadingAdd = false
                      })
                  }
              });
            },
            dialogClose() {
              this.form = {
                  qr_code_num: "",
                  staff_id: "",
              }
              // 重置字段验证
              this.$refs["form"].resetFields();
            },
            exportExcel(type) {
              this.$confirm("确定要导出列表数据吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success"
              }).then(() => {
                  let url = '';
                  for(var k in this.data){
                    let value = this.data[k] !==undefined ? this.data[k] : '';
                    if (k == 'page') { continue }
                    url += `&${k}=${encodeURIComponent(value)}`
                  }
                  url += `&type=${type}`
                  if (this.loginInfo.id == 1) {
                    url += `&auth=xj2020`
                  }
                  location.href = this.loginInfo.app_url+'/manage/goods-order/excel?' + url.substring(1)
              }).catch(() => {
                  // 取消操作
              });
            },
        }
    }
</script>

<style>
</style>
